import {
    EKanbanCardProperty,
    IApplicationState,
    TBoardId,
    TCardId,
    TCustomPropertyId
} from '../../../../../../../../../types/types';
import { getCard } from '../../../../../../../../../store/model/selectors/getCard';
import {
    getBoardUserMetaCardPreviewCustomProperties
} from '../../../../../../../../../store/model/board/selectors/getBoardUserMetaCardPreviewCustomProperties';
import { ICardCustomProperties } from '../../../../../../../../../store/customProperties/types';

export const getShowKnbCardCustomProperties = (
    state: IApplicationState,
    boardId: TBoardId,
    cardId: TCardId,
): TCustomPropertyId[] => {
    const { meta } = getCard(state, cardId)
    const cardCustomProperties: ICardCustomProperties = meta && meta.customProperties || {};
    const showCustomProperties = getBoardUserMetaCardPreviewCustomProperties(state, boardId);
    const result = [];
    for (let id in cardCustomProperties) {
        const { value } = cardCustomProperties[id];
        if (
            value &&
            showCustomProperties.includes(EKanbanCardProperty.CUSTOM_PROPERTIES + id)
        ) {
            result.push(id);
        }
    }
    return result;
};
